import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalErrorHandlerService } from '@vmspdb/ui/common';

@Component({
  selector: 'vmspdb-fatal-error',
  templateUrl: './fatal-error.component.html',
  styleUrls: ['./fatal-error.component.scss'],
  standalone: false,
})
export class FatalErrorComponent {
  private router = inject(Router);
  private errors = inject(GlobalErrorHandlerService);

  url = '';

  reload() {
    if (this.url) {
      this.router
        .navigateByUrl(this.url, {
          onSameUrlNavigation: 'reload',
        })
        .catch((err) => this.errors.reportCatastrophicError(err, 'Fatal Load'));
      return;
    }

    window.location.reload();
  }
}
